var EstimateShipmentViewModule = (function (_app, _forms, _eventHandler) {
    return Backbone.View.extend({
        _template: 'bt-checkout-estimate-shipping',

        _hiddenClass: 'hidden-block',

        events: {
            'click @estimateSubmint': '_submin',
            'focus @estimatePostcode': '_showButton'
        },

        initialize: function (opts) {
            _.bindAll(this, '_submin', '_toggle', '_setCurrentValue', '_showButton', '_hideButton', '_inProgress');
            this._render();
            this.$el.insertBefore('@lastAddressContainer');
            this._toggle();

            _eventHandler && _eventHandler.on('display', this._toggle);
        },

        _toggle: function (e, form, opts) {
            var settings = CheckoutSettings.getBasketSettings();
            this.$el.toggleClass(this._hiddenClass, settings.ShippingByPostcodeEnabled !== true || form !== _forms.add && form !== undefined);
        },

        _render: function () {
            this.$el = $.tmpl(this._template);
            this._subscribe();
            this._setCurrentValue();
        },

        _showButton: function () {
            this.$('@estimateSubmint').removeClass(this._hiddenClass);
            this.$('@estimatePostcode').addClass('estimete-shipping-form-postcode__active');
            this.$('@estimatePostcode').removeClass('estimete-shipping-form-postcode');
            this.$('@estimateTick').addClass(this._hiddenClass);
        },

        _hideButton: function () {
            this.$('@estimateSubmint').addClass(this._hiddenClass);
            this.$('@estimatePostcode').removeClass('estimete-shipping-form-postcode__active');
            this.$('@estimatePostcode').addClass('estimete-shipping-form-postcode');
            this.$('@estimateTick').removeClass(this._hiddenClass);
        },

        _subscribe: function () {
            var postcodeModel = this._getPostcodeModel();
            if (postcodeModel) {
                this.$field = this.$('@estimatePostcode');
                this.$field.keyFilter(postcodeModel.get('MaxLength'), postcodeModel.get('Regexp'));
                postcodeModel.on('change:Value', this._setCurrentValue);
            }
            this.$('@estimateSubmint').on('inprogress', this._inProgress);
        },

        _inProgress: function(e, inProgress) {
            this.$('@estimateSubmint').toggleClass('estimete-shipping-form-button__processing', inProgress);
            !inProgress && this._hideButton();
        },

        _setCurrentValue: function () {
            var postcodeModel = this._getPostcodeModel();
            var postcode = postcodeModel && postcodeModel.get('Value');
            if (!postcode && window.localStorage) {
                var usepostcode = ((JSON.parse(localStorage.getItem('userPostCode')) || '') + '') || null;
                postcode = usepostcode || '';
            }
            this.$('@estimatePostcode').val(postcode);
        },

        _getPostcodeModel: function () {
            return _app.models.delivery.decoration.where({ Name: 'Postcode' })[0];
        },

        _submin: function () {
            var postcode = this.$('@estimatePostcode').val();
            if (postcode) {
                var postcodeModel = this._getPostcodeModel();
                var currentPostcode = postcodeModel.get('Value');
                postcodeModel && postcodeModel.setValue(null);
                postcodeModel && postcodeModel.setValue(postcode);

                if (currentPostcode === postcode) {
                    this._hideButton();
                }

                if (window.localStorage) {
                    localStorage.setItem('userPostCode', JSON.stringify(postcode.toString()));
                }
            }
        }
    }); 
});